/**
 * Phase 3: Image protection (FR 7, FR 8).
 * Disable right-click and drag on an img element to reduce saving/copying.
 * Used globally and by ProtectedImage component.
 */
export function protectImageElement(img) {
  if (!img || img.nodeName !== 'IMG') return;
  if (img.dataset.protected === 'true') return;

  img.setAttribute('draggable', 'false');
  img.style.userSelect = 'none';
  img.dataset.protected = 'true';

  const preventContextMenu = (e) => e.preventDefault();
  const preventDrag = (e) => e.preventDefault();

  img.addEventListener('contextmenu', preventContextMenu);
  img.addEventListener('dragstart', preventDrag);

  img._imageProtectionCleanup = () => {
    img.removeEventListener('contextmenu', preventContextMenu);
    img.removeEventListener('dragstart', preventDrag);
    delete img.dataset.protected;
    delete img._imageProtectionCleanup;
  };
}

export function protectAllImagesInContainer(container = document) {
  const images = container.querySelectorAll ? container.querySelectorAll('img') : [];
  images.forEach(protectImageElement);
}
